<template>
    <edit-resource
        @close="$emit('close')"
        :form="form"
        :title="title"
        @submit="saveSignature"
    >
        <simple-input v-model="form.name" :errors="form.errors.name" class="mb-16">
            {{ $t('email_signatures.name') }}
        </simple-input>
        <wysiwyg class="mb-16" v-model="form.content" :errors="form.errors.content" with-links>{{ $t('email_signatures.content') }}</wysiwyg>

        <div v-if="currentUser.companies.length === 1">
            <toggle
                v-model="form.default_companies"
                :value="currentUser.companies[0].id"
            >{{ $t('email_signatures.set_default') }}</toggle>
        </div>

        <div v-else>
            <h2 class="mb-8 font-semibold">{{ $t('email_signatures.set_default_for_companies') }}</h2>
            <ul class="-space-y-px rounded relative">
                <li
                    v-for="(company, index) in currentUser.companies.sort((a, b) => a.name.localeCompare(b.name))"
                    :key="'company-signature-' + company.id"
                    class="border trans-ease p-12"
                    :class="[ !index ? 'rounded-t' : (index === currentUser.companies.length - 1 ? 'rounded-b' : ''),
                    form.default_companies.includes(company.id) ? 'border-secondary-80 bg-secondary-5 relative z-10' : 'border-primary-20 bg-white' ]"
                >
                    <toggle
                        v-model="form.default_companies"
                        :value="company.id"
                    >{{ company.name }}</toggle>
                </li>
            </ul>
        </div>
    </edit-resource>
</template>

<script>
import Form from '../etc/forms/Form';
import EmailSignature from '../models/EmailSignature';
import Input from './forms/Input.vue';
import Wysiwyg from './forms/Wysiwyg.vue';
import EditResource from './ui/EditResource.vue';
import * as signatures from '../services/EmailSignatureService';
import { normalizeJson } from '../../shared/helpers';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../state/modules/authentication';
import Checkbox from './forms/Checkbox.vue';
import Toggle from './forms/Toggle.vue';
import CompanyUser from '../models/CompanyUser';
import Company from "../models/Company";

export default {
    components: {
        'edit-resource': EditResource,
        'simple-input': Input,
        'wysiwyg': Wysiwyg,
        'checkbox': Checkbox,
        'toggle': Toggle,
    },
    props: {
        signature: EmailSignature,
        title: String,
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentUser']),
    },
    methods: {
        generateForm () {
            let fields = [
                { name: 'name', value: '', required: true },
                { name: 'content', value: '', required: true },
                { name: 'default_companies', value: [] }
            ];

            if (this.signature) {
                fields.forEach((field, index) => {

                    if (field.name === 'default_companies') {
                        fields[index].value = this.signature.associatedCompanies.map(company => company.id);
                    } else {
                        fields[index].value = JSON.parse(JSON.stringify(this.signature[field.name]));
                    }
                });
            }

            return new Form(fields);
        },
        async saveSignature () {
            if (this.signature && this.signature.id) {
                await this.updateSignature();
            } else {
                await this.createSignature();
            }

            this.$emit('close');
        },
        createSignature () {
            return this.form.submit(data => signatures.store({
                data: {
                    attributes: {
                        name: data.name,
                        content: data.content,
                    },
                    relationships: {
                        default_companies: data.default_companies,
                    }
                }
            })).then(result => {
                return useRepo(EmailSignature).save(normalizeJson(result));
            });
        },
        updateSignature () {
            return this.form.submit(data => signatures.update(this.signature.id, {
                data: {
                    attributes: {
                        name: data.name,
                        content: data.content,
                    },
                    relationships: {
                        default_companies: data.default_companies,
                    }
                }
            })).then(result => {
                useRepo(CompanyUser)
                    .where('default_email_signature_id', result.id)
                    .update({default_email_signature_id: null});

                useRepo(EmailSignature).save(normalizeJson(result))
            });
        }
    }
}
</script>
